import { IPaymentReviewSummary } from "./paymentReviewSummary.types"

export class PaymentReviewSummary implements IPaymentReviewSummary {
  constructor(
    public completed: number,
    public failed: number,
    public skipped: number,
    public total: number,
  ) {}
}
